var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "error-form",
      attrs: {
        model: _vm.formData,
        "label-width": "0",
        "label-position": "top",
        size: "mini",
      },
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.formData.arr, border: "" } },
        [
          _c("el-table-column", {
            attrs: { "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.ExpenseType"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".feeTypeCode",
                          rules: _vm.rules.feeTypeCode,
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("basicData.PleaseSelect"),
                            },
                            model: {
                              value: scope.row.feeTypeCode,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "feeTypeCode", $$v)
                              },
                              expression: "scope.row.feeTypeCode",
                            },
                          },
                          _vm._l(_vm.feeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.displayName + "(" + item.code + ")",
                                value: item.code,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.QuantityStartTicketNotIncluded"),
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("basicData.QuantityStartTicketNotIncluded")
                          )
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".startOfGoodsQuantity",
                          rules: {
                            required: true,
                            suffix: "2",
                            negative: "",
                            negative1: 1,
                            package: scope.row.endOfGoodsQuantity,
                            validator: _vm.Integer0,
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: scope.row.startOfGoodsQuantity,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "startOfGoodsQuantity", $$v)
                            },
                            expression: "scope.row.startOfGoodsQuantity",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.EndOfVolumeTicketIncluded"),
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("basicData.EndOfVolumeTicketIncluded"))
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".endOfGoodsQuantity",
                          rules: {
                            required: true,
                            suffix: "2",
                            negative: "",
                            negative1: 2,
                            package: scope.row.startOfGoodsQuantity,
                            validator: _vm.Integer0,
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: scope.row.endOfGoodsQuantity,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "endOfGoodsQuantity", $$v)
                            },
                            expression: "scope.row.endOfGoodsQuantity",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.PricePerTicket"),
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.PricePerTicket"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".price",
                          rules: {
                            required: true,
                            suffix: 2,
                            negative: "",
                            negative2: 9,
                            validator: _vm.priceType,
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: scope.row.price,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "price", $$v)
                            },
                            expression: "scope.row.price",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("basicData.operate"), width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDel(scope.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.Delete")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }